import { transport } from 'config/transport';

export function callApiReorderStudents(classId) {
    return transport.put(`/mamnon/classes/${classId}/students/reorder`);
}
